import React from 'react';
import { message } from 'antd';
import Icon from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as CheckedCircleSvg } from '@/images/icons/checked_circle.svg';
import { ReactComponent as MessageFailIcon } from '@/images/icons/message-fail.svg';
import { ReactComponent as LoadingCircleSvg } from '@/images/icons/message_loading_blue.svg';
import { ReactComponent as NetErrorSvg } from '@/images/icons/wifi_closed.svg';
import { getIn18Text } from 'api';
import styles from './SiriusMessage.module.scss';
const CheckedCircleIcon = (props) => React.createElement(Icon, Object.assign({ component: () => React.createElement(CheckedCircleSvg, null) }, props));
const LoadingCircleIcon = (props) => React.createElement(Icon, Object.assign({ component: LoadingCircleSvg }, props));
const NetErrorIcon = (props) => React.createElement(Icon, Object.assign({ component: NetErrorSvg }, props));
const MessageFail = (props) => React.createElement(Icon, Object.assign({ component: () => React.createElement(MessageFailIcon, null) }, props));
const mergeClassNames = (localCalssName, className) => {
    if (className) {
        return `${localCalssName} ${className}`;
    }
    return localCalssName || '';
};
const mergeArgs = (params, defaultClassName) => {
    let args;
    if (typeof params === 'object') {
        args = params;
    }
    else {
        args = {
            content: params,
        };
    }
    return Object.assign(Object.assign({}, args), { className: mergeClassNames(defaultClassName, args.className) });
};
class SiriusMessage {
    constructor() {
        this.useMessage = message.useMessage;
        this.config = message.config;
        this.antMessage = message;
        this.warning = this.warn;
    }
    success(params, duration, onClose) {
        return this.antMessage.success(Object.assign({ icon: React.createElement(CheckedCircleIcon, null) }, mergeArgs(params, styles.siriusMessageSuccess)), duration, onClose);
    }
    info(params, duration, onClose) {
        return this.antMessage.info(mergeArgs(params, styles.siriusMessageInfo), duration, onClose);
    }
    error(params, duration, onClose) {
        return this.antMessage.error(mergeArgs(params, styles.siriusMessageError), duration, onClose);
    }
    fail(params, duration, onClose) {
        return this.antMessage.error(Object.assign({ icon: React.createElement(MessageFail, null) }, mergeArgs(params, styles.siriusMessageError)), duration, onClose);
    }
    warn(params, duration, onClose) {
        return this.antMessage.warn(mergeArgs(params, styles.siriusMessageWarn), duration, onClose);
    }
    netWorkError() {
        return this.antMessage.warn({
            icon: React.createElement(NetErrorIcon, { fill: "none" }),
            content: getIn18Text('CAOZUOSHIBAI\uFF0C'),
            duration: 1.5,
        });
    }
    loading(params, duration, onClose) {
        return this.antMessage.loading(Object.assign({ icon: React.createElement(LoadingCircleIcon, { fill: "none", spin: true, size: "16" }) }, mergeArgs(params, styles.siriusMessageInfo)), duration, onClose);
    }
    open(args) {
        return this.antMessage.open(args);
    }
    destroy(messageKey) {
        return this.antMessage.destroy(messageKey);
    }
}
export default new SiriusMessage();
